<template>
  <v-dialog v-model="showDialog" width="800px" :fullscreen="fullscreen">
    <v-card color="cardSurface safeAreaLeft safeAreaRight">
      <v-card-title
        class="mb-2 flex-column justify-center text-center safeAreaTop"
      >
        <h1 class="primary--text">Signer</h1>
      </v-card-title>
      <v-card-text>
        <v-text-field v-model="fullName" label="Navn" filled></v-text-field>

        <div class="signatureDiv">
          <VueSignaturePad
            class="signature"
            id="signature"
            ref="signaturePad"
            :options="{
              onBegin: () => {
                $refs.signaturePad.resizeCanvas();
              },
            }"
          />
        </div>
      </v-card-text>
      <v-card-actions class="justify-center safeAreaBottom">
        <v-btn
          class="px-12 py-5"
          color="secendary"
          depressed
          light
          @click="clear"
        >
          Resett
        </v-btn>
        <v-btn
          class="px-12 py-5"
          color="primary"
          depressed
          light
          @click.stop="save"
        >
          Signer
        </v-btn>
        <v-btn
          class="px-12 py-5"
          color="cardBtnBadge"
          depressed
          @click.stop="showDialog = false"
        >
          Avbryt
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import notification from "@/helpers/notification";
import Vue from "vue";

export default Vue.extend({
  name: "BaseDialog",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      fullName: "",
    };
  },
  methods: {
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    clear() {
      this.$refs.signaturePad.clearSignature();
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

      if (!this.fullName) {
        notification.warn("Du må fylle inn navn");
        return;
      }

      if (isEmpty || !data) {
        notification.warn("Du må signere");
        return;
      }

      var signature = {
        dataUrl: data,
        fullName: this.fullName,
        isEmpty: isEmpty,
        uuid: Date.now(),
        updated: new Date(),
      };
      this.$emit("save", signature);
    },
  },
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    fullscreen() {
      return this.$vuetify.breakpoint.mobile;
    },
  },
});
</script>

<style lang="scss" scoped>
.safeAreaTop {
  padding-top: calc(16px + env(safe-area-inset-top)) !important;
}
.safeAreaBottom {
  padding-bottom: calc(8px + env(safe-area-inset-bottom)) !important;
}
.safeAreaRight {
  padding-right: calc(0px + env(safe-area-inset-right)) !important;
}
.safeAreaLeft {
  padding-left: calc(0px + env(safe-area-inset-left)) !important;
}
</style>

<style lang="scss">
.signature {
  background-color: var(--v-lightGrey-base) !important;
}
.signatureDiv {
  width: 100%;
  height: 300px;
}
</style>
